var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-spotlight"},[_c('div',{staticClass:"card-spotlight__inner"},[_c(_vm.componentName,{tag:"component",attrs:{"content":_vm.content}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }